<script>
  import { onMount } from "svelte";

  let { http, toastr, goTo } = $props();

  let activeInWorkspace = $state([]);
  let notInCentrum = $state([]);
  let notInWszyscy = $state([]);
  let skippedUsernames = $state([]);
  let loading = $state(true);

  onMount(() => {
    http.get("/api/issues.php").then(
      (response) => {
        loading = false;
        if (response.data.status == 200) {
          activeInWorkspace = response.data.active_in_workspace;
          notInCentrum = response.data.not_in_centrum;
          notInWszyscy = response.data.not_in_wszyscy;
          skippedUsernames = response.data.skipped_usernames ?? [];
        } else {
          toastr.error("Błąd pobierania problemów: " + response.data.message);
        }
      },
      (response) => {
        loading = false;
        toastr.error("Błąd pobierania problemów: " + response.status);
      },
    );
  });

  function createMemberFromWorkspace(user) {
    goTo("member-edit", {
      id: -1,
      prefill: {
        imie: user.given_name,
        nazwisko: user.family_name,
        email_mjn: user.email,
        email: user.personal_email || null,
        nrtel: user.phone || null,
        data_uchwaly: user.created_at ? user.created_at.split("T")[0] : null,
        typ: user.suspended ? 4 : 1,
      },
    });
  }
</script>

<h3><i class="fas fa-exclamation-circle fa-lg"></i>&nbsp;&nbsp;Problemy</h3>
<div class="clearfix"></div>

{#if loading}
<div class="text-muted">Ładowanie...</div>
{/if}

{#if !loading}
<div>
    <h4>Byli członkowie aktywni w Workspace</h4>
    <p class="text-muted">
        <small>Osoby oznaczone w Centrum jako Były członek, których konto Google Workspace jest nadal aktywne.</small>
    </p>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
            <tr>
                <th>Imię i nazwisko</th>
                <th>E-mail MJN</th>
                <th>E-mail prywatny</th>
            </tr>
        </thead>
        <tbody>
            {#if activeInWorkspace.length === 0}
            <tr>
                <td colspan="3" class="text-muted">Brak problemów</td>
            </tr>
            {/if}
            {#each activeInWorkspace as m}
            <tr>
                <td><a href={"/member-detail/" + m.idcz}>{m.imie} {m.nazwisko}</a></td>
                <td>{m.email_mjn}</td>
                <td>{m.email}</td>
            </tr>
            {/each}
        </tbody>
    </table>

    <h4>Aktywni członkowie nieobecni w grupie "wszyscy"</h4>
    <p class="text-muted">
        <small>Członkowie aktywni w Centrum Sterowania, którzy nie są członkami grupy Workspace "wszyscy".</small>
    </p>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
            <tr>
                <th>Imię i nazwisko</th>
                <th>E-mail MJN</th>
            </tr>
        </thead>
        <tbody>
            {#if notInWszyscy.length === 0}
            <tr>
                <td colspan="2" class="text-muted">Brak problemów</td>
            </tr>
            {/if}
            {#each notInWszyscy as m}
            <tr>
                <td><a href={"/member-detail/" + m.idcz}>{m.imie} {m.nazwisko}</a></td>
                <td>{m.email_mjn}</td>
            </tr>
            {/each}
        </tbody>
    </table>

    <h4>Konta Workspace bez wpisu w Centrum</h4>
    <p class="text-muted">
        <small>Konta Google Workspace, dla których nie ma odpowiadającego email_mjn w Centrum Sterowania.</small>
        {#if skippedUsernames.length > 0}
        <br><small>Ignorowane konta specjalne: {skippedUsernames.join(", ")}</small>
        {/if}
    </p>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
            <tr>
                <th>Imię i nazwisko</th>
                <th>E-mail</th>
                <th>Utworzono</th>
                <th>Status</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            {#if notInCentrum.length === 0}
            <tr>
                <td colspan="5" class="text-muted">Brak problemów</td>
            </tr>
            {/if}
            {#each notInCentrum as u}
            <tr>
                <td>{u.given_name} {u.family_name}</td>
                <td>{u.email}</td>
                <td>{u.created_at ? u.created_at.split("T")[0] : ""}</td>
                <td>
                    {#if u.suspended}<span class="text-muted">zawieszone</span>{/if}
                    {#if !u.suspended}<span class="text-danger">aktywne</span>{/if}
                </td>
                <td>
                    <button class="btn btn-xs btn-primary" onclick={() => createMemberFromWorkspace(u)}>
                        <i class="fas fa-user-plus"></i>&nbsp;Utwórz członka
                    </button>
                </td>
            </tr>
            {/each}
        </tbody>
    </table>
</div>
{/if}
